export { default } from './info-badge';
